export const CitationCampaignSx = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    paddingTop: { xs: '16px', sm: '24px' },
    paddingBottom: { xs: '16px', sm: '20px' },
    flexDirection: { xs: 'column', sm: 'row' },
    gap: { xs: '12px', sm: '0px' },
    width: '100%',
    boxSizing: 'border-box'
  },
  headerTitleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: '8px', sm: '12px' }
  },
  headerTitle: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: { xs: '20px', sm: '24px', md: '30px' },
    lineHeight: { xs: '28px', sm: '32px', md: '38px' },
    color: 'var(--color-primary)'
  },
  helpIcon: {
    width: '20px',
    height: '20px',
    color: 'rgba(168, 166, 191, 1)',
    '&:hover': {
      color: 'var(--color-primary)'
    }
  },
  hideLocationContainer: {
    border: '1px solid var(--color-text-muted-purple)',
    borderRadius: '6px',
    padding: { xs: '8px 12px', sm: '10px 16px' },
    display: 'flex',
    alignItems: 'center',
    gap: { xs: '8px', sm: '12px' },
    width: { xs: '100%', sm: 'auto' },
    justifyContent: { xs: 'space-between', sm: 'flex-start' }
  },
  hideLocationLabel: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '14px', sm: '14px' },
    lineHeight: { xs: '20px', sm: '20px' },
    color: 'var(--color-primary)'
  },

  hideLocationSwitch: {
    width: '48px',
    height: '26px',
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: '3px',
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        color: 'var(--color-white)',
        '& + .MuiSwitch-track': {
          backgroundColor: 'var(--color-primary)',
          opacity: 1,
          border: 0
        }
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: 'var(--color-primary)',
        border: '4px solid var(--color-white)'
      }
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: '20px',
      height: '20px'
    },
    '& .MuiSwitch-track': {
      borderRadius: '13px',
      backgroundColor: 'var(--color-bg-mid-grey)',
      opacity: 1,
      transition: 'background-color 300ms'
    }
  },
  outerContainer: {
    width: '100%',
    marginTop: 0,
    marginBottom: { xs: '16px', sm: '24px' },
    boxSizing: 'border-box'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', lg: 'row' },
    gap: { xs: '20px', sm: '24px', lg: '32px' },
    maxWidth: '1400px',
    margin: '0 auto',
    width: '100%'
  },
  servicesContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '16px', sm: '20px' }
  },
  serviceCard: {
    backgroundColor: 'var(--color-white)',
    borderRadius: { xs: '8px', sm: '12px' },
    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
    overflow: 'hidden',
    padding: { xs: '16px', sm: '20px', md: '24px' }
  },
  warningBanner: {
    display: 'flex',
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: { xs: '8px', sm: '8px' },
    backgroundColor: 'var(--color-warning-pale)',
    padding: { xs: '10px 12px', sm: '12px 20px' },
    border: '1px solid var(--color-warning-orange)',
    borderRadius: { xs: '6px', sm: '8px' },
    marginBottom: { xs: '12px', sm: '16px' }
  },
  warningIcon: {
    width: '20px',
    height: '20px',
    flexShrink: 0
  },
  warningText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '12px', sm: '14px' },
    lineHeight: { xs: '16px', sm: '20px' },
    color: 'var(--color-primary)',
    flex: 1,
    wordBreak: 'break-word'
  },
  serviceCardContent: {},
  serviceHeaderRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'flex-start' },
    gap: { xs: '12px', sm: '20px' },
    marginBottom: { xs: '12px', sm: '6px' }
  },
  serviceHeader: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: { xs: '12px', sm: '20px' },
    width: '100%'
  },
  serviceTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '18px', sm: '24px' },
    lineHeight: { xs: '26px', sm: '32px' },
    color: 'var(--color-primary)',
    marginBottom: '4px'
  },
  recommendedChip: {
    backgroundColor: 'var(--color-bg-success-light)',
    color: 'var(--color-success-deep)',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    height: '24px',
    '& .MuiChip-label': {
      padding: '6px 16px'
    }
  },
  featuresContainer: {
    marginBottom: { xs: '16px', sm: '20px' }
  },
  whatsIncludedLabel: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '14px', sm: '15px' },
    lineHeight: { xs: '20px', sm: '22px' },
    color: 'var(--color-primary)',
    marginBottom: { xs: '12px', sm: '16px' }
  },
  whatsIncludedLabelNoMargin: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '14px', sm: '15px' },
    lineHeight: { xs: '20px', sm: '22px' },
    color: 'var(--color-primary)',
    marginBottom: 0
  },
  tableHeadContainer: {
    paddingLeft: { xs: '0px', sm: '24px' },
    paddingRight: { xs: '0px', sm: '24px' }
  },
  featureItem: {
    display: 'flex',
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: { xs: '8px', sm: '12px' },
    marginBottom: { xs: '8px', sm: '12px' },
    '&:last-child': {
      marginBottom: 0
    },
    '& ul': {
      listStyleType: 'disc',
      paddingLeft: { xs: '18px', sm: '20px' },
      margin: 0,
      width: '100%'
    },
    '& li': {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: { xs: '12px', sm: '14px' },
      lineHeight: { xs: '16px', sm: '20px' },
      color: 'var(--color-text-secondary)',
      marginBottom: { xs: '4px', sm: '6px' },
      wordBreak: 'break-word'
    }
  },
  checkIcon: {
    width: { xs: '18px', sm: '20px' },
    height: { xs: '18px', sm: '20px' },
    flexShrink: 0,
    marginTop: '2px'
  },
  featureText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '13px', sm: '14px' },
    lineHeight: { xs: '18px', sm: '20px' },
    color: 'var(--color-text-muted)',
    flex: 1,
    wordBreak: 'break-word'
  },
  serviceActions: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: { xs: '8px', sm: '12px' },
    alignItems: { xs: 'stretch', sm: 'center' },
    width: { xs: '100%', sm: 'auto' },
    minWidth: { xs: '100%', sm: 'auto' }
  },
  quantityLabel: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '13px', sm: '14px' },
    lineHeight: { xs: '18px', sm: '20px' },
    color: 'var(--color-text-secondary)',
    whiteSpace: { xs: 'nowrap', sm: 'normal' }
  },
  removeButton: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '13px', sm: '14px' },
    textTransform: 'none',
    padding: { xs: '8px 12px', sm: '8px 12px' },
    border: '1px solid var(--color-border-muted)',
    minHeight: { xs: '44px', sm: '44px' },
    width: { xs: '100%', sm: 'auto' }
  },
  addToOrderButton: {
    color: 'var(--color-white)',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '14px', sm: '16px' },
    lineHeight: { xs: '20px', sm: '24px' },
    padding: { xs: '10px 18px', sm: '8px 18px' },
    borderRadius: '6px',
    width: { xs: '100%', sm: 'max-content' },
    minHeight: { xs: '44px', sm: 'auto' }
  },
  orderSidebar: {
    width: { xs: '100%', lg: '380px' },
    backgroundColor: 'var(--color-white)',
    borderRadius: { xs: '8px', sm: '12px' },
    border: '1px solid rgba(0, 0, 0, 0.1)',
    boxShadow: '0px 1px 8px 0px var(--color-shadow-card)',
    paddingTop: { xs: '16px', sm: '24px' },
    paddingBottom: { xs: '16px', sm: '24px' },
    paddingLeft: { xs: '0px', sm: '0px' },
    paddingRight: { xs: '0px', sm: '0px' },
    height: 'fit-content',
    position: { lg: 'sticky' },
    top: { lg: '24px' },
    overflow: { xs: 'hidden', sm: 'visible' }
  },
  orderTitle: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '18px', sm: '24px' },
    lineHeight: { xs: '26px', sm: '32px' },
    color: 'var(--color-primary)',
    paddingLeft: { xs: '16px', sm: '24px' },
    paddingRight: { xs: '16px', sm: '24px' },
    marginBottom: { xs: '8px', sm: '0px' }
  },
  tableContainer: {
    border: 'none',
    boxShadow: 'none',
    borderRadius: '2px',
    marginTop: { xs: '12px', sm: '24px' },
    overflowX: { xs: 'auto', sm: 'visible' },
    '& .MuiTable-root': {
      borderCollapse: 'separate',
      borderSpacing: 0,
      minWidth: { xs: '300px', sm: 'auto' }
    }
  },
  tableHeaderRow: {
    '& .MuiTableCell-root': {
      borderTop: 'none',
      borderBottom: '2px solid var(--color-bg-purple-tint)',
      backgroundColor: 'rgba(247, 244, 252, 1)',
      padding: { xs: '10px 0', sm: '14px 0' },
      whiteSpace: { xs: 'nowrap', sm: 'normal' },
      '&:first-of-type': {
        paddingLeft: { xs: '16px', sm: '24px' }
      },
      '&:last-of-type': {
        paddingRight: { xs: '16px', sm: '24px' }
      }
    }
  },
  tableHeadText: {
    fontFamily: 'Inter',
    fontSize: { xs: '13px', sm: '14px' },
    fontWeight: 600,
    lineHeight: { xs: '20px', sm: '20px' },
    textAlign: 'left',
    color: 'var(--color-text-purple)'
  },
  tableCellItem: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: { xs: '13px', sm: '12px' },
    lineHeight: { xs: '18px', sm: '18px' },
    color: 'var(--color-primary)',
    paddingTop: { xs: '12px !important', sm: '16px !important' },
    paddingBottom: { xs: '12px !important', sm: '16px !important' },
    paddingLeft: { xs: '16px !important', sm: '24px !important' },
    paddingRight: { xs: '8px !important', sm: '0px !important' },
    borderBottom: '1px solid var(--color-border-medium)',
    wordBreak: { xs: 'break-word', sm: 'normal' },
    maxWidth: { xs: '200px', sm: 'none' }
  },
  tableCellPrice: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: { xs: '13px', sm: '12px' },
    lineHeight: { xs: '18px', sm: '18px' },
    color: 'var(--color-primary)',
    paddingTop: { xs: '12px !important', sm: '16px !important' },
    paddingBottom: { xs: '12px !important', sm: '16px !important' },
    paddingLeft: { xs: '8px !important', sm: '0px !important' },
    paddingRight: { xs: '16px !important', sm: '24px !important' },
    borderBottom: '1px solid var(--color-border-medium)',
    whiteSpace: { xs: 'nowrap', sm: 'normal' }
  },
  orderTotalContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: { xs: '12px 16px', sm: '12px 24px' },
    marginTop: { xs: '8px', sm: '0px' }
  },
  orderTotalLabel: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: { xs: '16px', sm: '20px' },
    lineHeight: { xs: '24px', sm: '30px' },
    color: 'var(--color-text-secondary)'
  },
  orderTotalAmount: {
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: { xs: '22px', sm: '20px' },
    lineHeight: { xs: '30px', sm: '30px' },
    color: 'var(--color-primary)'
  },
  orderButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '10px', sm: '16px' },
    padding: { xs: '12px 16px', sm: '12px 24px' },
    marginTop: { xs: '8px', sm: '0px' }
  },
  confirmButton: {
    backgroundColor: 'var(--color-primary)',
    color: 'var(--color-white)',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '14px', sm: '16px' },
    lineHeight: { xs: '20px', sm: '24px' },
    padding: { xs: '10px 20px', sm: '12px 24px' },
    borderRadius: '6px',
    textTransform: 'none',
    width: '100%'
  },
  saveButton: {
    borderColor: 'var(--color-primary)',
    color: 'var(--color-primary)',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '14px', sm: '16px' },
    lineHeight: { xs: '20px', sm: '24px' },
    padding: { xs: '10px 20px', sm: '12px 24px' },
    borderRadius: '6px',
    textTransform: 'none',
    width: '100%'
  },
  helpTooltipText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  subtitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: { xs: '8px', sm: '0px' },
    marginBottom: { xs: '12px', sm: '20px' }
  },
  subtitleLabel: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: { xs: '14px', sm: '16px' },
    lineHeight: { xs: '20px', sm: '24px' },
    color: 'var(--color-text-muted)'
  },
  priceText: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: { xs: '14px', sm: '16px' },
    lineHeight: { xs: '20px', sm: '24px' },
    color: 'var(--color-primary)'
  },
  checkmarkCircle: {
    width: { xs: '20px', sm: '36px' },
    height: { xs: '20px', sm: '36px' },
    minWidth: { xs: '20px', sm: '36px' },
    minHeight: { xs: '20px', sm: '36px' },
    borderRadius: '50%',
    backgroundColor: 'var(--color-success-bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: { xs: '2px', sm: '0px' },
    '& img': {
      width: { xs: '12px', sm: '16px' },
      height: { xs: '12px', sm: '16px' }
    }
  },
  divider: {
    margin: { xs: '8px', sm: '10px' }
  },
  filterDropdownStyles: {
    filterBoxSx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      backgroundColor: 'white',
      minWidth: { xs: '100%', sm: 'max-content' },
      width: { xs: '100%', sm: 'auto' },
      minHeight: '44px',
      borderRadius: '6px',
      padding: { xs: '8px 12px', sm: '8px 16px' },
      border: '1px solid var(--color-border-muted)',
      gap: { xs: '8px', sm: '16px' }
    },
    selectedFilterSx: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: 'var(--font-size-14)',
      lineHeight: 'var(--line-height-20)',
      color: 'var(--color-primary)'
    },
    optionBox: {
      px: 2,
      py: 1,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'var(--color-bg-grey)'
      }
    },
    selectedOptionText: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: 'var(--font-size-14)',
      lineHeight: 'var(--line-height-20)',
      color: 'var(--color-primary)'
    },
    nonSelectedOptionText: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: 'var(--font-size-14)',
      lineHeight: 'var(--line-height-20)',
      color: 'var(--color-text-dark2)'
    }
  }
};
